import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Container } from '@mui/material';
import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header/Header';
import { Colors } from '../themes/theme';
export var MainLayout = function () { return (_jsxs(Box, { position: "relative", minHeight: "100vh", children: [_jsx(Box, { sx: {
                backgroundColor: Colors.AZUL_GOV,
                height: '18rem',
                width: '100%',
                position: 'absolute',
                top: 0,
                zIndex: -1,
            } }), _jsx(Header, {}), _jsx(Container, { children: _jsx(Box, { mt: 1, children: _jsx(Outlet, {}) }) })] })); };
